import { render, staticRenderFns } from "./LogisticsNodes.vue?vue&type=template&id=6bc3c462"
import script from "./LogisticsNodes.vue?vue&type=script&lang=js"
export * from "./LogisticsNodes.vue?vue&type=script&lang=js"
import style0 from "./LogisticsNodes.vue?vue&type=style&index=0&id=6bc3c462&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports